type ClassDisplayLike = {
  name?: string | null;
  section?: string | null;
  owner?: {
    lastName?: string | null;
  } | null;
};

export const formatClassDisplayName = (cls: ClassDisplayLike): string => {
  const className = cls.name?.trim() ?? '';
  const sectionName = cls.section?.trim();
  const teacherLastName = cls.owner?.lastName?.trim();

  const parts: string[] = [];

  if (className) parts.push(className);
  if (sectionName) parts.push(sectionName);
  if (teacherLastName) parts.push(teacherLastName);

  return parts.join(' - ');
};
